import { useEffect, useState } from 'react'
import { useAuthenticatedFetch } from '../lib/api'
import type { ModelConfig } from '../lib/models'

interface ReadyDataset {
  id: string
  name: string
  trigger_word: string | null
  lora_status: string
}

// Fetch the authenticated user's ready LoRAs and expose them as
// ModelConfig entries so any component that renders the model picker can
// treat them the same as base models.
export default function useLoraModels(): ModelConfig[] {
  const authenticatedFetch = useAuthenticatedFetch()
  const [loras, setLoras] = useState<ModelConfig[]>([])

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await authenticatedFetch('/api/datasets')
        const { data } = (await res.json()) as { data: ReadyDataset[] }
        if (cancelled) return
        const ready = data.filter((d) => d.lora_status === 'ready')
        setLoras(
          ready.map((d) => ({
            id: `lora:${d.id}`,
            name: `LoRA · ${d.name}`,
            provider: 'replicate',
            hf_model_id: '',
            type: 'image',
            nsfw: false,
            default_steps: 28,
            default_width: 1024,
            default_height: 1024,
            speed: '~10s',
            description: d.trigger_word
              ? `Custom LoRA (trigger: ${d.trigger_word})`
              : 'Custom LoRA',
            cost_estimate: '~$0.025',
          })),
        )
      } catch {
        // Non-fatal — just show no LoRAs
      }
    })()
    return () => {
      cancelled = true
    }
  }, [authenticatedFetch])

  return loras
}
